import React from "react";
import { Tooltip } from "antd";
import { PlusOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { StyledSpace, OperationButton } from "./styles";
import { OperationButtonsProps } from "./types";

export const OperationButtons: React.FC<OperationButtonsProps> = ({
  operations,
  onClone,
  onDelete,
  onVisibility,
  disabled = false,
}) => {
  if (!operations?.actions) {
    return null;
  }

  const handleClick = (e: React.MouseEvent, handler?: () => void) => {
    e.stopPropagation();
    if (!disabled && handler) {
      handler();
    }
  };

  const renderButton = (
    type: "clone" | "delete" | "visibility",
    defaultIcon: React.ReactNode,
    defaultTooltip: string,
    onClick?: () => void
  ) => {
    const operation = operations.actions?.[type];
    if (!operation) return null;

    return (
      <Tooltip title={operation.tooltip || defaultTooltip}>
        <OperationButton
          type="text"
          icon={operation.icon || defaultIcon}
          onClick={(e: React.MouseEvent) => {
            handleClick(e, onClick);
          }}
          disabled={disabled || operation.disabled}
        />
      </Tooltip>
    );
  };

  return (
    <StyledSpace onClick={(e) => e.stopPropagation()}>
      {renderButton("clone", <PlusOutlined />, "克隆", onClone)}
      {renderButton("visibility", <EyeOutlined />, "显示/隐藏", onVisibility)}
      {renderButton("delete", <DeleteOutlined />, "删除", onDelete)}
    </StyledSpace>
  );
};
